import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { LicenseInfo } from "@mui/x-license-pro";
import theme from "./theme";
import App from "./App";

// Apply MUI X Pro license key
const KEY =
    process.env.REACT_APP_MUI_X_LICENSE_KEY ||
    process.env.MUI_X_LICENSE_KEY;
if (KEY) {
    LicenseInfo.setLicenseKey(KEY);
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Router>
                    <App />
                </Router>
            </LocalizationProvider>
        </ThemeProvider>
    </React.StrictMode>
);